import { render, staticRenderFns } from "./CreatorsClubPromoBannerCompact.vue?vue&type=template&id=2965145a&scoped=true"
import script from "./CreatorsClubPromoBannerCompact.vue?vue&type=script&lang=js"
export * from "./CreatorsClubPromoBannerCompact.vue?vue&type=script&lang=js"
import style0 from "./CreatorsClubPromoBannerCompact.vue?vue&type=style&index=0&id=2965145a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965145a",
  null
  
)

export default component.exports